module.exports = __webpack_public_path__ + "static/img/card_left.7c1e81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/card_left.png
// module id = uncR
// module chunks = 1